import { render, staticRenderFns } from "./UIMobileHorizontalPortfolioCard.vue?vue&type=template&id=9d479b2e&scoped=true"
import script from "./UIMobileHorizontalPortfolioCard.vue?vue&type=script&lang=js"
export * from "./UIMobileHorizontalPortfolioCard.vue?vue&type=script&lang=js"
import style0 from "./UIMobileHorizontalPortfolioCard.vue?vue&type=style&index=0&id=9d479b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d479b2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PortfolioRankTag: require('/skade-pwa/components/ui/atom/PortfolioRankTag.vue').default,PortfolioPrivacyTag: require('/skade-pwa/components/ui/atom/PortfolioPrivacyTag.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
